import React from 'react';
import { NavListItemLink } from '../common/NavListItemLink';

export const SidebarNav = () => (
  <ul className="nav flex-column gap-0">
    <h6 className="nav-list-title">Spaces</h6>
    <NavListItemLink to="/spaces">Overview</NavListItemLink>

    <li>
      <hr className="nav-divider" />
    </li>

    <h6 className="nav-list-title">System</h6>
    <NavListItemLink to="/system/components">Components</NavListItemLink>
    <NavListItemLink to="/system/licensing">Licensing</NavListItemLink>
    <NavListItemLink to="/system/setup">Setup</NavListItemLink>
  </ul>
);
